module.exports = __webpack_public_path__ + "static/img/mn.9ebe47eb.svg";